import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {UserState} from "../../api/models/user-state";
import {Subscription} from "rxjs";
import {GlobalApp} from "../../tools/global";
import {SubscriptionService} from "../../api/services/subscription.service";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import { US_ReportStandardLayout, US_ReportstandardType } from "../../api/models";
import { ReportExportService } from "../../api/services";
import { MessageDialogComponent } from "../../dialogs/message-dialog/message-dialog.component";

@Component({
  selector: "powerbi-report-home",
  templateUrl: "./powerbi-report-home.component.html",
})
export class PowerBiReportHomeComponent implements OnInit, OnDestroy {

  @Input() showHeader: boolean = true;

  selectedValues: string[] = [];

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false
  };

  userStateSubscription: Subscription = null;

  currentSelectedReport: US_ReportstandardType | undefined = undefined;
  currentSelectedLayout: US_ReportStandardLayout | undefined = undefined;
  currentSelectedAction: string = undefined;

  isLoading: boolean = false;

  constructor(
    public app: GlobalApp,
    private reportExportService: ReportExportService,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private dialog: MatDialog
  ) {

    this.app.getAuthorizationStatus().subscribe((result) => {
      this.app.refreshUserState(this.subscriptionService);
    });
  }

  ngOnInit() {
    this.isLoading = true;

    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;

      const lastStatus = this.app.getLastStatus();
      if (lastStatus.lastReportStandardTypeId) {
        this.currentSelectedReport = this.userState.reportExportState.reportStandardTypes.find(x => x.reportStandardTypeId === lastStatus.lastReportStandardTypeId);

        if (this.currentSelectedReport && lastStatus.lastReportStandardLayoutId) {
          this.currentSelectedLayout = this.currentSelectedReport.layouts.find(x => x.reportStandardLayoutId === lastStatus.lastReportStandardLayoutId);
        }
      }
      else {
        this.currentSelectedReport = this.userState.reportExportState.reportStandardTypes[0];
        this.currentSelectedLayout = this.currentSelectedReport.layouts[0];
      }
      this.currentSelectedAction = 'Generate';
      this.isLoading = false;
    });
  }

  ngOnDestroy() {
    this.userStateSubscription.unsubscribe();
  }

  selectReport() {
    if (!this.isLoading) {
      this.currentSelectedLayout = undefined;
      this.app.setLastReport(this.currentSelectedReport?.reportStandardTypeId, undefined);
    }
  }

  selectLayout() {
    if (!this.isLoading) {
      this.app.setLastReport(this.currentSelectedReport?.reportStandardTypeId, this.currentSelectedLayout?.reportStandardLayoutId);
    }
  }

  goClick(): boolean {

    if (this.currentSelectedReport && this.currentSelectedLayout && this.currentSelectedAction) {
      this.reportExportService.reportExportReportExportRequest(this.currentSelectedLayout.reportStandardLayoutId).subscribe((_) => {
        MessageDialogComponent.showDialog(this.dialog, "Success", "Export Generation Submitted.  See exports tab in My Reports for progress.").subscribe((_) => { });
      });
    }

    return false;
  }
}
